import {commonConstant,deviceModelConstant} from '@/utils/Constants';
import {i18n} from '@/utils/i18nUtil.js';

const commonUtil = {};

// 获取登录的token
commonUtil.getLoginToken = ()=>{
  return localStorage.getItem(commonConstant.TOKEN_NAME)
          || sessionStorage.getItem(commonConstant.TOKEN_NAME);
}

// 获取登录的用户
commonUtil.getLoginUser = ()=>{
  return JSON.parse(sessionStorage.getItem(commonConstant.LOGIN_USER_KEY));
}

// 深度克隆对象
commonUtil.deepClone = (obj) => {
  let objClone = Array.isArray(obj) ? [] : {};
  if (obj && typeof obj === "object") {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        //判断obj子元素是否为对象，如果是，递归复制
        if (obj[key] && typeof obj[key] === "object") {
            objClone[key] = commonUtil.deepClone(obj[key]);
        } else {
            //如果不是，简单复制
            objClone[key] = obj[key];
        }
      }
    }
  }
  return objClone;
}

// el-autocomplete记录历史数据
commonUtil.querySearch = (queryString, callback,key) => {
  let history = JSON.parse(localStorage.getItem(key));
  if(!history){
    history = [];
  }
  //根据输入的值与历史搜索的数组进行匹配
  let results = queryString ? history.filter(commonUtil.createFilter(queryString)) : history;
  callback(results);
}
commonUtil.createFilter = (queryString) => {
  return (restaurant) => {
    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
  };
}
commonUtil.handleInputSelect = (item,key) => {
  let history = JSON.parse(localStorage.getItem(key));
  if(history){
    history = history.filter((obj)=>{
      return obj.value != item.value;
    });
  }else{
    history = [];
  }
  history.unshift(item);
  history = history.slice(0, 8);
  localStorage.setItem(key,JSON.stringify(history));
}
commonUtil.handleInputValue = (value,key) => {
  if(value){
    let history = JSON.parse(localStorage.getItem(key));
    if(history){
      history = history.filter((obj)=>{
        return obj.value != value;
      });
    }else{
      history = [];
    }
    let item = {value};
    history.unshift(item);
    history = history.slice(0, 8);
    localStorage.setItem(key,JSON.stringify(history));
  }
}

// el-table横行拖动，tableDataRef表示需要进行拖拽的表格的dom
commonUtil.dragTable = (tableDataRef) => {
  let mouseFlag = false;
  let mouseStart = 0;
  let startX = 0;
  let tableBody = null;
  tableDataRef.$el.addEventListener('mousedown', (e) => {
    tableBody = tableDataRef.bodyWrapper;
    mouseFlag = true;
    mouseStart = e.clientX;
    startX = tableBody.scrollLeft;
    tableBody.style.cursor = 'grab';
  });
  tableDataRef.$el.addEventListener('mouseup', () => {
    mouseFlag = false;
    tableBody.style.cursor = 'auto';
  });
  tableDataRef.$el.addEventListener('mousemove', (e) => {
    e.preventDefault();
    if (mouseFlag) {
      let offset = e.clientX - mouseStart;
      tableBody.scrollLeft = startX - offset;
    }
  });
};

// 将数据配置，转换为对象key-value
commonUtil.handleSettingToObject = (settings) => {
  let param = {};
  for (let key in settings) {
    param[key] = {};
    let children = settings[key].children;
    for (let childKey in children) {
      param[key][childKey] = children[childKey].settingValue;
    }
  }
  return param;
}

// 将根据图片base64编码，转换为image可辨别值
commonUtil.handleBase64ToImage = (base64,imageType) => {
  return `data:image/${imageType};base64,${base64}`;
}

// 有梯厂业务的权限
commonUtil.hasElevatorFactoryAuth = () => {
  let loginUser = commonUtil.getLoginUser();
  let allowUsers = ['admin', 'administrator', 'xiaolongjun', '13128703158'];
  return loginUser && allowUsers.includes(loginUser.userAccount) && !commonUtil.isHongKongHost();
}

// 用户角色显示的标签类型
commonUtil.getTagType = (roleId) => {
  switch (roleId){
    case 1: // 大客户
      return '';
    case 2: // 代理
      return 'success';
    case 3: // 客户
      return 'warning';
    case 4: // 项目
      return 'danger';
    default: // 管理员或其它
      return 'info';
  }
}

// 根据设备类型返回机型
commonUtil.getModelByDeviceType = (deviceType) => {
  switch (deviceType){
    case 'D600':
    case 'D800':
    case 'D601':
      return deviceModelConstant.MANAGEMENT;
    case 'D900':
      return deviceModelConstant.VOICE_GATEWAY;
    case 'G400':
    case 'P400':
    case 'T400':
      return deviceModelConstant.EXTENSION;
    case 'G300':
      return deviceModelConstant.VOICE_EXTENSION;
    default:
      return i18n.t('unknownText');
  }
}

// 自定义验证价格
/* commonUtil.validatePrice = (rule, value, callback) => {
  const priceRegex = /^[1-9]\d*(\.\d{1,2})?$/;
  if (!value || priceRegex.test(value)) {
    callback();
  } else {
    callback(new Error('请输入正确的价格，最多保留两位小数!'));
  }
} */

// 是否为管理员
commonUtil.isAdmin = () => {
  let loginUser = commonUtil.getLoginUser();
  if(!loginUser.roleId || loginUser.roleId < 1){
    return true;
  }
  return false;
}

// 递归获取指定 roleId 层级的用户对象
commonUtil.getUserByRoleId = (user, roleId) => {
  if (!user || roleId == null) {
    return null;
  }
  if (user.roleId == roleId) {
    return user;
  }
  return commonUtil.getUserByRoleId(user.parent, roleId);
}

// 字符前补0
commonUtil.padZero = (num, n) => {
  let len = num.toString().length;
  while (len < n) {
    num = "0" + num;
    len++;
  }
  return num;
}

// 关闭popover
commonUtil.closePopover = () =>{
  document.dispatchEvent(new MouseEvent('click', {
    view: window, // 指定事件的视图上下文为 window 对象，表示事件发生在哪个视窗中
    bubbles: true, // 设置事件冒泡为 true，使事件可以从目标元素向上传播到父元素
    cancelable: true // 设置事件可取消为 true，允许调用 preventDefault() 来取消事件的默认行为
  }));
}

// 计算设备信号强度
commonUtil.calculateSignal = (rssi) => {
  if (rssi > 0 && rssi <= 12) {
    return i18n.t('device.rssiVeryWeak');
  } else if (rssi > 12 && rssi <= 15) {
    return i18n.t('device.rssiWeak');
  } else if (rssi > 15 && rssi <= 19) {
    return i18n.t('device.rssiMedium');
  } else if (rssi > 19 && rssi <= 25) {
    return i18n.t('device.rssiStrong');
  } else if (rssi > 25 && rssi <= 31) {
    return i18n.t('device.rssiVeryStrong');
  } else {
    return i18n.t('device.rssiNone');
  }
}

// 生成指定范围内的随机数
commonUtil.getRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export default commonUtil;

// 为香港平台
commonUtil.isHongKongHost = () => {
  return process.env.HOST == commonConstant.HONG_KONG_HOST;
}

// 敏感文本处理
commonUtil.handleSensitiveText = (text) => {
  if(text){
    // 长度大于2时，将中间字符替换为*，否则只替换最后一个字符
    if(text.length > 2){
      return text.substring(0,1) + '*'.repeat(text.length - 2) + text.substring(text.length - 1);
    }else if(text.length == 2){
      return text.substring(0,1) + '*';
    }
  }
  return '';
}


// WEBPACK FOOTER //
// ./src/utils/commonUtil.js